import React, { useState, useEffect, useContext } from 'react';
import { ProgressBar } from "react-bootstrap";

import * as net from "../../../lib/net";
import * as q from '../../../lib/defer';

import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import Fr_Input from "../../../lib/ui/fr_input";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ddo from "../../../ddo";

  
const ProgressCtrl = (props) => {
    const { bgcolor, completed } = props;

    const containerStyles = {
        height: 20,
        width: '100%',
        backgroundColor: "#e0e0de",
        borderRadius: 50,
        margin: 0
    }

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: bgcolor,
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: "width .6s ease"
    }

    const labelStyles = {
        padding: "0 5",
        width: '100%',
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center'
    }

    return (
        <div style={containerStyles}>
            <div style={fillerStyles}>
                <div style={labelStyles}>{`${completed}%`}</div>
            </div>
        </div>
    );
};

class Plu_Import extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.today = new Date();
    this.state.lsa = [];
    this.state.lso = {};
    //this.state.lro = props.lro;
    this.state.tya = [
                {id: '02', text: 'Dag för dag'},
                {id: '01', text: 'Summerad'}
            ];
    this.state.dea = [
                {id: '01', text: 'Definition v1'},
                {id: '02', text: 'Definition v2'}
            ];
    this.state.cols = {};
    this.state.lrwrk = false;
    //context.posrend = this;
    this.state.favd = "";
    this.state.tavd = "";
    this.state.fdat = "";
    this.state.tdat = "";
    this.state.typ = "";
    this.state.def = "";
      this.state.msg = {};
      this.state.mx = {};
    this.state.pdf = 0;
    this.state.pdf_content = null;
      this.state.loading = 0;
      this.state.procup = 25;
      this.state.mnunr = "1";
      this.state.importFile = null;
      this.state.sheetid = "";
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.dlg_init();
  }

  dlg_init() {
      var state = this.state;
      state.favd = ddo.cache.avd;
      state.tavd = ddo.cache.avd;
      state.typ = "02";
      state.def = "01";
      state.loading = 0;
      if(this.pos.deps && this.pos.deps.length) {
          state.favd = this.pos.deps[0].avd;
          state.tavd = this.pos.deps[0].avd;
      }
    this.setState(state);
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    tab_head(tabid) {
      var css = {};
      css.background = "#fff";
      css.color = "#000";
      if(this.state.tabval === tabid) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
    }
  change_avd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({avd: avd});
  }
  change_typ(e) {
    //let cdat = this.state.seldate;
    let typ = e.target.value;
    this.setState({typ: typ});
  }
  change_def(e) {
    //let cdat = this.state.seldate;
    let def = e.target.value;
    this.setState({def: def});
  }

    import_ing() {
        var self = this;

        if(false) {
            this.setState({procup: 40});
            return;
        }
        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar INGREDIENSER..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_ingred.ingred_import";
        prm.avd = this.state.avd;
        prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.ok));

                var msg = { info: false, ok: true, text: "INGREDIENSER importerade..."};
                self.setState({msg: msg });
                setTimeout(function(){
                    self.setState({msg: {} });
                }, 1000);
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    import_pluing() {
        var self = this;

        if(false) {
            this.setState({procup: 40});
            return;
        }
        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar PLUS INGREDIENSER..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_ingred.pluing_import";
        prm.avd = this.state.avd;
        prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.ok));

                var msg = { info: false, ok: true, text: "PLUS INGREDIENSER importerade..."};
                self.setState({msg: msg });
                setTimeout(function(){
                    self.setState({msg: {} });
                }, 1000);
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

    import_plus() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar PLU..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_plu.plu_import";
        prm.avd = this.state.avd;
        prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "PLU importerade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    import_upd() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar Uppdatering..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_plu.plu_import_upd";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "PLU Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }

    import_wine() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar Wine..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_pluwine_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "Wine Uppdaterad..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }

    import_am() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar AM..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "AM Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    import_am_ean() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar AM EAN..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_ean_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "AM EAN Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    import_am_lev() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar AM LEV..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_lev_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "AM LEV Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    import_am_pg() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar AM PG..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_pg_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "AM PG Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    import_am_sg() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Importerar AM SG..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_am.am_sg_import";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "AM SG Uppdaterade..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }

    xml2excel() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Exporterar XML..."};
        self.setState({msg: msg });

        var prm = {};
        prm.req = "pos.pos_plu.xml2excel";
        prm.avd = this.state.avd;
        //prm.mnunr = this.state.mnunr;
        //alert(JSON.stringify(prm));
        //return;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.ok));

            var msg = { info: false, ok: true, text: "Excel Skapad..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }

  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  body_style() {
      var css = {};
      css.display = "";
      if( this.state.loading == 1 ) css.display = "none";
      return css;
  }
    wnd_close = () => {
        this.props.ctx.setState({ wnds: {} });
    };

    onFileChange(e) {
        //alert(JSON.stringify(e.target.files[0].name));
        //this.setState({ importFile: e.target.files[0] });
        this.setState({ importFile: e });
      };

    toBase64(file) {
        var defer = q.defer();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            //console.log(reader.result);

            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            if ((encoded.length % 4) > 0) {
              encoded += '='.repeat(4 - (encoded.length % 4));
            }
      
            defer.resolve(encoded);
          };
          reader.onerror = function (error) {
            //console.log('Error: ', error);
            defer.reject();
          };
       
        return defer.promise;
    };

    async onFileUpload() {
        var self = this;
        var importfile = this.state.importFile;

        if(importfile == null) {
            alert("Ingen fil vald");
            return;
        }
        //if(self.state.sheetid.length < 1) {
        //    alert("Ingen flik angiven");
        //    return;
        //}
        
        if (importfile.type !== 'application/vnd.ms-excel' && importfile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            alert('Please select a XLS or XLSX file.');
            return;
        }
        
        if (importfile.size > (1024 * 1024 * 32) ) {
            alert('File size should not exceed 32 MB.');
            return;
        }

        //var fileform = document.getElementById("fileform");
        //alert(JSON.stringify(this.state.importFile));

        /*
        const formData = new FormData();
        //alert(JSON.stringify(formData));
        formData.append(
          "importFile",
          importfile,
          importfile.name
        );

        const reader = new FileReader();
        reader.onloadend = () => {
            alert(reader.result);
            // Logs data:<type>;base64,wL2dvYWwgbW9yZ...
        };
        reader.readAsDataURL(importfile);
        */
        
        //var txt = await importfile.text();
        //alert( txt );
        //alert( btoa(formData) );
        //alert(JSON.stringify(formData));
    
        // axios.post("api/uploadfile", formData);
        //var base64 = base64Encode(importfile);

        self.toBase64(importfile)
        .then(function(ret) {

            //alert(JSON.stringify(ret));
            if(!ret || (ret.length < 1)) {
                alert("Ingen fil vald");
                return;
            }
    
            var prm = {};
            prm.req = "pos.pos_plu.impfil";
            prm.avd = self.state.avd;
            prm.sheetid = self.state.sheetid;
            prm.ff = ret;
            //prm.fil64 = txt;
            //alert(JSON.stringify(prm));
            //return;
    
            net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.ok));
    
                var msg = { info: false, ok: true, text: "Fil importerad..."};
                self.setState({msg: msg });
                setTimeout(function(){
                    self.setState({msg: {} });
                }, 1000);
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
                alert("Misslyckades med fil");
            });
    
        })
    
    };
    
  render() {
    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_rp flex-col" style={ this.dlg_style() }>
        <div className="mx_head mx_bg flex-row flex-space-between">
            <div className="flex-col flex">
                <div>IMPORTERA PLU</div>
            </div>
            <div className="white-icon-close" onClick={() => this.wnd_close() }>X</div>
        </div>
        { this.state.loading ? <div className="mx_content flex align-items-center justify-content-center"><FontAwesomeIcon icon="spinner" spin size="3x" fixed /></div> :
        null }
        <div className="mx_content flex" style={ this.body_style() }>
            <div className="flex-row px-2">
                    <div className="flex-col flex">
                        <div>Start</div>
                    </div>
                    <div className="flex-col flex">
                        <div></div>
                    </div>
                    <div className="flex-col w50">
                        <div>Ändra</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div className="flex">

            <div className="flex-row">
                <div className="flex"></div>
              <div className="flex-col">
                  <span>Avdelning</span>
        <select className="form-control input-rp-01 w250" placeholder="Avdelning" onChange={(e) => this.change_avd(e)}>
            { this.pos.deps.map((row, key) =>
            <option key={key} value={row.avd}>{row.avd} - {row.text.toswe()}</option>
            )}
        </select>
            </div>
                <div className="flex"></div>
            </div>
            <div className="flex-row">
                <div className="flex"></div>
                <Fr_Input noflex label="Meny Nr" col className="text-center w250" text={this.state.mnunr} getValue={(e)=> this.setState( { mnunr: e }) } />
                <div className="flex"></div>
            </div>

            <div className="flex-row">
                <div className="flex"></div>
                <Fr_Input noflex type="file" accept=".xlsx, .xls, .csv" label="Fil att importera" col className="text-center w250" getValue={(e)=> this.onFileChange(e) } />
                <div className="flex"></div>
            </div>
            <div className="flex-row">
                <div className="flex"></div>
                <Fr_Input noflex label="Flik Namn" col className="w250" text={this.state.sheetid} getValue={(e)=> this.setState( { sheetid: e }) } />
                <div className="flex"></div>
            </div>
            <div className="flex-row">
                <div className="flex"></div>
                <div className="">Kolumner: Plu, Text, Pris, Happy, Varugrupp, Varugrupp, Momskod, K1, K2, K3, B1, B2</div>
                <div className="flex"></div>
            </div>

            <div className="flex-row hide">
              <div className="flex-col">
                  <span>Typ</span>
        <select className="form-control input-rp-01 w250" placeholder="Typ" onChange={(e) => this.change_typ(e)}>
            { this.state.tya.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
            </div>
              <div className="flex-col">
                  <span>Konto Definition</span>
        <select className="form-control input-rp-01 w250" placeholder="Definition" onChange={(e) => this.change_def(e)}>
            { this.state.dea.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
            </div>
            </div>

            <div className="flex-row hide">
                <div className="flex-col flex">
                    <ProgressCtrl bgcolor="#800" completed={ this.state.procup }/>
                    <ProgressBar now={ this.state.procup } label={ this.state.procup }/>
                </div>
            </div>
            <div className="flex-row hide">
                <div className="flex-col">
                    <span>Import fil</span>
                    <input type="file" onChange={this.onFileChange} />
                </div>
            </div>

        </div>

        </div>

        <div className="mx_foot flex-col">

        <div className="flex-row">
                <div className="web-link txt_16 px-2" onClick={() => this.import_wine() }>IMPORT WINES</div>
                <div className="flex"></div>
        </div>
        <div className="flex-row">
                <div className="web-link txt_16 px-2" onClick={() => this.import_am() }>IMPORT AM</div>
                <div className="web-link txt_16 px-2" onClick={() => this.import_am_ean() }>IMPORT AM EAN</div>
                <div className="web-link txt_16 px-2" onClick={() => this.import_am_lev() }>IMPORT AM LEV</div>
                <div className="flex"></div>
                <div className="web-link txt_16 px-2" onClick={() => this.import_am_pg() }>IMPORT AM GRP</div>
                <div className="web-link txt_16 px-2" onClick={() => this.import_am_sg() }>IMPORT AM SUB</div>
        </div>
        <div className="flex-row">
                <div className="web-link txt_16 px-2" onClick={() => this.import_upd() }>IMPORT UPD</div>
                <div className="flex"></div>
                <div className="web-link txt_16 px-2" onClick={() => this.xml2excel() }>XML 2 EXCEL</div>
                <div className="web-link txt_16 px-2" onClick={() => this.import_plus() }>IMPORT INTERN</div>
           </div>
            <div className="flex-row">
                <div className="flex-row flex">
                <div className="btn-rp" onClick={() => this.wnd_close() } >
                    <div>STÄNG</div>
                    <div><FontAwesomeIcon icon="times" size="2x" /></div>
                </div>
            </div>
            <div className="flex-row">
                <div className="btn-rp" onClick={() => this.import_pluing() } >
                    <div>IMPORTERA PLUS INGREDIENSER</div>
                    <div><FontAwesomeIcon icon="at" size="2x" /></div>
                </div>
                <div className="btn-rp" onClick={() => this.import_ing() } >
                    <div>IMPORTERA INGREDIENSER</div>
                    <div><FontAwesomeIcon icon="at" size="2x" /></div>
                </div>
                <div className="btn-rp" onClick={() => this.onFileUpload() } >
                    <div>IMPORTERA FIL</div>
                    <div><FontAwesomeIcon icon="at" size="2x" /></div>
                </div>
            </div>
            </div>
        </div>

      </div>
            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Info msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Plu_Import;